import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Collapse, Table } from 'antd';
import { apiConfig } from '../../../REST';
import { IExportType, IMonthlyInvoices } from '../../../interfaces';
import { useProfile } from '../../../hooks';
import { getMonthlyInvoices } from '../../../middleware';
import { tF, tI } from '../../../translate';
import { FileTypeIcons, LoadingApiByIds } from '../../../Components';
import '../../../customStyle/table.less';
import StylesIcon from '../../IconComponents/m_styles.less';
import StylesLink from '../../LinkComponent/m_styles.less';
import ViewStyles from '../../styles/m_viewStyles.less';

const { Panel } = Collapse;

interface IMonthlyUsageItem {
    startDate: string;
    endDate: string;
    myCompanyId: string;
}

export const MonthlyUsageItem: React.FC<IMonthlyUsageItem> = observer(
    ({ myCompanyId, startDate, endDate }: IMonthlyUsageItem) => {
        const { currency } = useProfile();
        const [list, setList] = useState<IMonthlyInvoices[]>([]);
        const [isOpen, setIsOpen] = useState<boolean>(false);

        const _getMonthlyUsageListItem = async () => {
            const invoices = await getMonthlyInvoices({
                companyId: myCompanyId,
                startDate,
                endDate,
            });

            setList(invoices);
        };

        useEffect(() => {
            if (isOpen) {
                _getMonthlyUsageListItem();
            }
        }, [isOpen]);

        const tableColumns = [
            {
                title: 'Number',
                dataIndex: 'number',
            },
            {
                title: tF('Date'),
                dataIndex: 'createdAt',
            },
            {
                title: tF('Type'),
                dataIndex: 'type',
            },
            {
                title: tF('Amount'),
                dataIndex: 'amount',
            },
            {
                title: tF('File'),
                dataIndex: 'fileLink',
            },
        ];

        const onOpen = (key: string | string[]) => {
            setIsOpen(key?.includes('1'));
        };

        const tableData = list.map((r: IMonthlyInvoices, index) => {
            const fileType = r.file_url.split('.')[1] as IExportType;
            const IconType = fileType ? <FileTypeIcons fileType={fileType} className={StylesIcon.icon} /> : null;

            return {
                key: r.id,
                number: r.code,
                createdAt: r.date,
                type: r.invoicing_type,
                amount: `${r.amount}${currency}`,
                fileLink: (
                    <a className={StylesLink.linkItem} href={`${apiConfig.apiUrl()}${r.file_url}`} title={r.file_url}>
                        {IconType}
                    </a>
                ),
            };
        });

        return (
            <Collapse onChange={onOpen}>
                <Panel key={1} header={'Invoices'} forceRender={true}>
                    <div className={ViewStyles.tablePlace}>
                        <Table
                            className={'table-theme'}
                            columns={tableColumns}
                            dataSource={tableData}
                            pagination={false}
                            size={'middle'}
                        />
                    </div>
                    <LoadingApiByIds idSpinners={['GET_MONTHLY_USAGE_INVOICES']} />
                </Panel>
            </Collapse>
        );
    },
);
